<div class="bg-mg-accent-light rounded-full md:w-[100px] px-2 py-1 flex items-center gap-1">
    <mg-icon iconClass="text-mg-accent-dark" iconName="newspaper"></mg-icon>
    <div class="text-sm font-semibold text-mg-accent-dark md:inline-block hidden">
        Noticias
    </div>
</div>